import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { ProductDetailsTab, IVariantForm } from '../state/product-details.state';

@Injectable()
export class UrlStorageService {
  readonly DEFAULT_TAB = 'about';

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  save(tab: string, variantForm: IVariantForm, license?: string) {
    let params = new HttpParams();
    params = params.set('tab', tab);

    // Skip tab if same as defaults
    if (tab) {
      if (tab === this.DEFAULT_TAB) {
        params = params.delete('tab');
      }
    }

    if (variantForm) {
        params = params.set('language', variantForm.language);
        params = params.set('deliveryFormat', variantForm.deliveryFormat);
        if(variantForm.certificateType) params = params.set('certificateType', variantForm.certificateType);
        if(license) params = params.set('license', license);
    }


    const paramsToPersist = {};
    params.keys().forEach(p => (paramsToPersist[p] = params.getAll(p)));
    const yOffset = window.scrollY;
    this.router
      .navigate([], { relativeTo: this.route, queryParams: paramsToPersist, replaceUrl: true })
      .then(() => window.scrollTo(0, yOffset));
  }

  restore(): { tab: ProductDetailsTab, language: string, deliveryFormat: string, certificateType: string, license: string } {
    const lastParams = new TypedParamMap<{ tab: string, license: string } & IVariantForm>(this.route.snapshot.queryParamMap) ;
    const tab = lastParams.get('tab') as ProductDetailsTab;
    const language = lastParams.get('language');
    const deliveryFormat = lastParams.get('deliveryFormat');
    const certificateType = lastParams.get('certificateType');
    const license = lastParams.get('license');

    return { tab, language, deliveryFormat, certificateType, license };
  }
}

export class TypedParamMap<T> {
  constructor(public readonly paramMap: ParamMap) {}

  get(name: keyof T): string {
    return this.paramMap.get(name as string);
  }

  getAll(name: keyof T): string[] {
    return this.paramMap.getAll(name as string);
  }
}
